// store/StoreHeader.jsx
// Store profile header: cover banner (background_image), profile circle (profile_image),
// store name (username), product count, WhatsApp contact button.
// Props: store — { username, profile_image, background_image, phone_number, product_count }

import React from "react";
import { Store, MessageCircle } from "lucide-react";
import { brand } from "../shared/brand";

const WA_BASE = "https://wa.me/51";

export function StoreHeader({ store }) {
  if (!store) return null;

  const { username, profile_image, background_image, phone_number, product_count } = store;

  const waHref = phone_number
    ? `${WA_BASE}${phone_number.replace(/\D/g, "")}?text=${encodeURIComponent(`Hola ${username}, vi tu tienda en Fast Max y quiero consultar sobre tus productos.`)}`
    : null;

  return (
    <div className="relative mb-16">

      {/* Cover banner */}
      <div
        className="h-40 sm:h-52 w-full overflow-hidden"
        style={{
          background: background_image
            ? undefined
            : `linear-gradient(135deg, ${brand.primary} 0%, #7c1f45 100%)`,
        }}
      >
        {background_image && (
          <img
            src={background_image}
            alt={`${username} portada`}
            className="h-full w-full object-cover"
          />
        )}
        {/* Subtle dark gradient at bottom so profile circle stays legible */}
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-white/60 to-transparent" />
      </div>

      {/* Profile circle — overlaps banner */}
      <div className="absolute left-4 sm:left-8" style={{ bottom: -48 }}>
        <div
          className="size-24 sm:size-28 rounded-full border-4 border-white shadow-lg overflow-hidden bg-white flex items-center justify-center"
          style={{ background: brand.primary + "18" }}
        >
          {profile_image ? (
            <img
              src={profile_image}
              alt={`${username} logo`}
              className="h-full w-full object-cover"
            />
          ) : (
            <Store className="size-10" style={{ color: brand.primary }} />
          )}
        </div>
      </div>

      {/* Name + meta row — sits below banner, right of profile circle */}
      <div className="pt-3 pl-32 sm:pl-40 pr-4 flex items-end justify-between gap-3 min-h-[48px]">
        <div>
          <h1 className="text-lg sm:text-xl font-extrabold text-slate-900 leading-tight">
            {username}
          </h1>
          {product_count > 0 && (
            <p className="text-xs text-slate-400 font-semibold mt-0.5">
              {product_count} producto{product_count !== 1 ? "s" : ""}
            </p>
          )}
        </div>

        {/* WhatsApp contact button */}
        {waHref && (
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 flex items-center gap-1.5 rounded-xl px-3 py-2 text-xs font-bold text-white shadow-sm"
            style={{ background: "#25d366" }}
          >
            <MessageCircle className="size-3.5" />
            Contactar
          </a>
        )}
      </div>
    </div>
  );
}